// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__18A56","newExpiryDate":"styles_newExpiryDate__1Bl0J","footer":"styles_footer__2s6Qo"};